var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',[_c('v-snackbar',{attrs:{"timeout":3000,"color":"red"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" This link is invalid or expired ")]),(_vm.loading)?_c('loading-circle'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }